module.exports = __webpack_public_path__ + "media/images/home/arrow-06988aadc44208d7712f078693640974.png";